<template>
  <div class="form-check">
    <input
      :name="name"
      type="checkbox"
      class="form-check-input"
      :class="{ checked: modelValue }"
      :id="id"
      :checked="modelValue"
      @change="$emit('update:modelValue', $event.target.checked)"
    >
    <label class="form-check-label" :class="labelClass" :for="id">
      <slot><b>{{ labelText }}</b></slot>
    </label>
    <slot name="error" />
  </div>
</template>

<script>
let index = 0;

export default {
  props: {
    label: String,
    labelClass: String,
    modelValue: Boolean,
    name: String,
  },
  emits: ['update:modelValue'],
  data: () => ({
    id: `checkbox-${++index}`,
  }),
  computed: {
    labelText() {
      return this.label ? this.$t(this.label) : '';
    },
  },
};
</script>
